/**
 * StoneDopErrorType
 */
export enum StoneDopErrorType {
    General = 'general',
}
